import IDot from "../interfaces/dotImg";
import CirBlue from "../images/circles/blue.svg";
import CirBrown from "../images/circles/brown.svg";
import CirButter from "../images/circles/butter.svg";
import CirGrass from "../images/circles/green.svg";
import CirGrey from "../images/circles/grey.svg";
import CirLime from "../images/circles/lime.svg"; //unused
import CirMaroon from "../images/circles/maroon.svg";
import CirNavy from "../images/circles/navy.svg";
import CirPeach from "../images/circles/peach.svg";
import CirRed from "../images/circles/red.svg";
import CirSkin from "../images/circles/skin.svg";
import CirTea from "../images/circles/tea.svg";
import CirTeal from "../images/circles/teal.svg";
import CirYellow from "../images/circles/yellow.svg"; //unused

const dots: IDot[] = [
	{
		color: "blue",
	  	img: CirBlue,
	  	alt: "Blue dot",
	},
	{
	  	color: "brown",
	  	img: CirBrown,
	  	alt: "Brown dot",
	},
	{
		color: "butter",
		img: CirButter,
		alt: "Butter dot",
	},
	{
		color: "grass",
		img: CirGrass,
		alt: "Grass dot",
	},
	{
		color: "grey",
		img: CirGrey,
		alt: "Grey dot",
	},
	{
		color: "lime",
		img: CirLime,
		alt: "Lime dot",
	},
	{
		color: "maroon",
		img: CirMaroon,
		alt: "Maroon dot",
	},
	{
		color: "navy",
		img: CirNavy,
		alt: "Navy dot",
	},
	{
		color: "peach",
		img: CirPeach,
		alt: "Peach dot",
	},
	{
		color: "red",
		img: CirRed,
		alt: "Red dot",
	},
	{
		color: "skin",
		img: CirSkin,
		alt: "Skin dot",
	},
	{
		color: "tea",
		img: CirTea,
		alt: "Tea dot",
	},
	{
		color: "teal",
		img: CirTeal,
		alt: "Teal dot",
	},
	{
		color: "yellow",
		img: CirYellow,
		alt: "Yellow dot",
	},
  ];

export default dots;
